/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationPeekDataSchema = z.object({
	id: z.string(),
	name: z.string(),
})

export type OrganisationPeekDataSchema = z.infer<typeof organisationPeekDataSchema>
